const socketDefaultState = {
  socketDisconnect: false,
  socketId: null,
  haveTriedToConnectWebsocket: false,
  websocketConnectionError: null,
}

export default socketDefaultState
